module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page",
    class: {
      'bg-white': _vm.$vuetify.breakpoint.width <= 1280
    },
    staticStyle: {
      "background-color": "black"
    }
  }, [_c('v-container', {
    staticClass: "no-top-nav no-side-space",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "login-outer"
  }, [_c('div', {
    class: {
      'login-view': _vm.$vuetify.breakpoint.width > 1280
    }
  }, [(_vm.$vuetify.breakpoint.width > 1280) ? _c('v-btn', {
    staticClass: "absolute ma-0 btn-close",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push("/")
      }
    }
  }, [_c('v-icon', {
    staticClass: "font-size-34",
    staticStyle: {
      "background-color": "black"
    }
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "auth"
  }, [(true) ? _c('div', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "align-items": "center",
      "height": "330px",
      "min-width": "300px",
      "gap": "5px"
    }
  }, [_c('div', [_c('img', {
    staticClass: "logo",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })]), _vm._v(" "), _c('strong', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Create new password")]), _vm._v(" "), _c('form', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center",
      "align-content": "center",
      "gap": "10px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column",
    class: {
      'has-error': _vm.errors.has('password')
    },
    staticStyle: {
      "width": "100%"
    }
  }, [_c('label', {
    attrs: {
      "for": "confirm_password"
    }
  }, [_vm._v("New password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5|max:16'),
      expression: "'required|min:5|max:16'"
    }],
    class: {
      input: true,
      'text-danger': _vm.errors.has('password'),
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('password')) ? _c('p', {
    staticClass: "text-danger text-xs-left"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("password")) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column",
    class: {
      'has-error': _vm.errors.has('confirm_password')
    },
    staticStyle: {
      "width": "100%"
    }
  }, [_c('label', {
    attrs: {
      "for": "confirm_password"
    }
  }, [_vm._v("Confirm password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm_password),
      expression: "confirm_password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }],
    class: {
      input: true,
      'text-danger': _vm.errors.has('confirm_password'),
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "confirm_password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirm_password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('confirm_password')) ? _c('p', {
    staticClass: "text-danger text-xs-left"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("confirm_password")) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('v-btn', {
    staticClass: "reset-btn",
    attrs: {
      "block": "",
      "round": "",
      "dark": "",
      "type": "submit"
    }
  }, [_vm._v("Reset")])], 1)]) : _vm._e()])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44b5ce12","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/reset_password.vue
// module id = 1706
// module chunks = 180